import { useCallback } from 'react';
import type { Permission } from '@mys/contracts';
import { holds } from '@mys/contracts/constants';
import { useSession } from './session.js';

/* ============================================================================
   What this account may do.  docs/ADMIN-ROADMAP.md 1.3
   ----------------------------------------------------------------------------
   One question, asked against the SAME LIST the API answers with. Since
   slice 1.4 that list is not a map in this bundle at all — it is
   `user.permissions`, which `/api/auth/me` and the login response carry, read
   by the API out of the `Role` row in the same query that loads the account.

   That matters for a reason a static map could not give: the owner can edit
   the matrix, and the next `/me` this dashboard makes already reflects it. No
   deploy, and no version of this file disagreeing with the server it is
   talking to. `apps/api/tests/permissions.test.ts` asserts the routes and the
   rows agree; this reads the same rows one step later.

   Imported from `@mys/contracts/constants`, never from the package index. The
   index re-exports every schema module, so one runtime import from it drags
   Zod into this bundle — 29 KB gzipped, which this dashboard has already paid
   once. The `Permission` type is type-only and therefore free. CLAUDE.md.

   **This is a courtesy, not a boundary.** Anyone can edit the JavaScript
   running on their own machine; `requirePermission` on the server is what
   actually refuses. What this buys is a screen that does not offer somebody a
   form the API will reject once they have filled it in.
   ========================================================================== */

/**
 * `const may = useCan(); may('invoices:settle')`
 *
 * False while the session is still loading, and false for a role whose grants
 * are empty — the same fail-closed answer the API gives, for the same reason:
 * an absent list is not a permissive one.
 */
export function useCan(): (permission: Permission) => boolean {
  const { user } = useSession();
  return useCallback(
    (permission: Permission) => (user ? holds(user.permissions, permission) : false),
    [user],
  );
}
